export type Optional<T> = T | null | undefined;

export function isEmpty<T>(input: Optional<T>): input is null | undefined {
    return !input;
}

/**
 * is true if the value is existing.
 *
 * @param value
 */
export function isPresent<T extends unknown>(
    value: null | undefined | T
): value is T {
    return !!value;
}
